import { Component, inject, OnDestroy, OnInit, input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { KEY_CODE_RETURN } from '../../global';
import { AuthStore } from '../../state/auth/auth.store';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { PasswordInputComponent } from '../../password-input/password-input.component';

@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
  standalone: true,
  imports: [
    PasswordInputComponent,
    CardModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    ButtonModule,
  ],
})
export class LoginCardComponent implements OnInit, OnDestroy {
  private readonly onDestroy = new Subject<void>();

  forgotPasswordPath = input<string>();

  email = new UntypedFormControl('', [Validators.required, Validators.email]);
  password = new UntypedFormControl('', [Validators.required]);

  invalidLogin = false;
  isLoggingIn = false;

  private authStore = inject(AuthStore);
  private router = inject(Router);

  isLoggedIn = this.authStore.isLoggedIn;

  constructor() {
    combineLatest([this.email.valueChanges, this.password.valueChanges])
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.invalidLogin = false;
      });

    toObservable(this.authStore.loginError)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((errorMsg) => {
        if (errorMsg) {
          this.invalidLogin = true;
        }
      });
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  handleKeyUp(event: any) {
    if (event.keyCode == KEY_CODE_RETURN) {
      this.login();
    }
  }

  async login() {
    this.isLoggingIn = true;
    await this.authStore.login(this.email.value, this.password.value);
    this.isLoggingIn = false;
  }
}
